import * as React from "react"
import styled from "styled-components"
import Card from "react-bootstrap/Card"
import { Button, Container } from "react-bootstrap"
import clearbit from "../../../images/logos/clearout_vs_clearbit_logo.png"

const StyledContainer = styled(Container)`
  .card {
    width: 28rem;
    text-align: center;
    border: 0px !important;
    margin-bottom: 15px;
    margin: 10px;
    border-radius: 10px;
    padding: 10px;
    box-shadow: rgb(59 59 59 / 17%) 0px 5px 10px 0px;
  }

  .buttonStyle:hover {
    color: #fff;
  }

  .card img {
    width: 200px;
    height: 100px;
  }

  .card-title {
    font-weight: bold;
  }

  .lists {
    padding-bottom: 30px;
  }

  .container-width {
    max-width: 90%;
    color: #4a4560 !important;
  }

  .card {
    transition: transform 0.3s ease-in-out;
  }

  .card:hover {
    transform: translateY(-20px);
  }
  .card:hover {
    transform: translateY(-20px);
  }

  .card:hover ~ .card {
    transform: translateY(0);
    transition-delay: 0.1s;
  }

  @media (max-width: 991px) {
    .lists {
      flex-wrap: wrap !important;
    }
  }
`

const CompareOthers = () => {
  return (
    <StyledContainer className="d-flex justify-content-center text-center">
      <div className="container-width">
        <div className="text-center mb-5 ">
          <h2 className="fw-bolder">
            What makes us stand out from other Email Verification Services?
          </h2>
          <p className="py-3">
            Just one key characteristic can't make something best, you've to
            combine and compare them all together to decide what's best for your
            business. Unequivocally, we've compiled the most popular options
            available in the market for you.
          </p>
        </div>
        <h2 className=" fw-bold pb-5">
          Clearout vs Other Email Verification Tools
        </h2>
        <div className="d-flex justify-content-center lists">
          <Card className="accurate py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-zerobounce.jpg"
              alt="clearout vs zerobounce"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-zerobounce/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-neverbounce.jpg"
              alt="clearout vs neverbounce"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-neverbounce/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-hunter.io_.jpg"
              alt="clearout vs hunter"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-hunter-io/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-xverify.jpg"
              alt="clearout vs Xverify"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-xverify/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
        </div>
        <div className="d-flex justify-content-center lists">
          <Card className="accurate py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-briteverify.jpg"
              alt="clearout vs briteverify"
              className="mx-auto mw-200"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-briteverify/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-kickbox.jpg"
              alt="clearout vs kickbox"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-kickbox/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src="https://ik.imagekit.io/debounce/wp-content/uploads/2019/03/alternatives-debounce.jpg"
              alt="clearout vs debounce"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-debounce/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
          <Card className="afforable py-4 card">
            <Card.Img
              variant="top"
              src={clearbit}
              alt="clearout vs debounce"
              className="mx-auto"
            />
            <Card.Body>
              <Button
                href="/clearout-vs-clearbit/"
                className="fw-bold btn btn-outline-primary buttonStyle"
                variant="outline-primary"
              >
                Compare
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </StyledContainer>
  )
}

export default CompareOthers
